import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDrafts } from '../contexts/DraftContext';
import Editor from './Editor';
import HomeTabs from './HomeTabs';
// import { useAuth } from '../lib/useAuth';

interface RouteEditorProps {
  isEditable?: boolean;
}

const RouteEditor: React.FC<RouteEditorProps> = ({ isEditable = true }) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { loadDraftFromRoute, createNewDraft } = useDrafts();

  useEffect(() => {
    console.log('RouteEditor: Loading draft for id:', id);
    if (!id) return; // No draft selected; show landing view
    loadDraftFromRoute(id);
  }, [id, loadDraftFromRoute]);

  // Remove the problematic navigation logic that was causing flickering
  // The route guard will handle validation, and we don't need automatic navigation

  if (!id) {
    return (
      <HomeTabs
        onCreateNewDraft={() => {
          const newId = createNewDraft();
          navigate(`/n/${newId}`);
        }}
      />
    );
  }

  return <Editor isEditable={isEditable} />;
};

export default RouteEditor;
